// extracted by mini-css-extract-plugin
export default {"hero":"hero-module--hero--2lDO9","bottomRightBG":"hero-module--bottomRightBG--1wqgn","topLeftBG":"hero-module--topLeftBG--bomUF"};